import { render, staticRenderFns } from "./UserDataCard.vue?vue&type=template&id=1e37ec38&scoped=true"
import script from "./UserDataCard.vue?vue&type=script&lang=js"
export * from "./UserDataCard.vue?vue&type=script&lang=js"
import style0 from "./UserDataCard.vue?vue&type=style&index=0&id=1e37ec38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e37ec38",
  null
  
)

export default component.exports